import React from 'react';
import DataDrivenArticlePage from '../components/articles/DataDrivenArticlePage';
import { usePageSeo } from '../hooks/usePageSeo';

const PAGE_TITLE = 'Battery Management System (BMS) | AUTOXIUM';
const PAGE_DESCRIPTION =
  'A complete engineering reference to the EV Battery Management System (BMS) — hardware and AUTOSAR ' +
  'software architecture, cell monitoring, the operating state machine, charging (ISO 15118, CC-CV), ' +
  'thermal management, cell balancing, SOC/SOH/SOP estimation, functional safety (ISO 26262), ' +
  'cybersecurity (ISO 21434), UDS diagnostics, and MIL/SIL/HIL validation.';

const BmsTechnicalArticlePage = () => {
  usePageSeo(PAGE_TITLE, PAGE_DESCRIPTION);
  return <DataDrivenArticlePage slug="article-bms" pdfSlug="bms" />;
};

export default BmsTechnicalArticlePage;
